<ng-rate-list-container></ng-rate-list-container>
<ng-rate-form-container></ng-rate-form-container>
<ng-rate-results-container></ng-rate-results-container>
